/**
 * Author: Valeria Sinnati
 * /ᐠ｡ꞈ｡ᐟ\  Campo di input con label: pillola piena su `soft`, come la barra
 *          "chiedi" dei visual. Il bordo è trasparente e si accende solo al
 *          focus (`accent-ink`: Deep Purple in chiaro, verde in scuro) o
 *          sull'errore, così il campo non disegna una riga in più a riposo.
 */
import type { InputHTMLAttributes } from 'react'
import { useId } from 'react'

export interface FieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string
  error?: string
}

/**
 *  /\____/\
 * > •    • <   #1
 */
export function Field({ label, error, className = '', ...props }: FieldProps) {
  const id = useId()
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id} className="text-sm font-semibold text-muted">
        {label}
      </label>
      <input
        id={id}
        className={
          'min-h-11 rounded-pill border-[1.5px] bg-soft px-4 py-2.5 text-foreground ' +
          'placeholder:text-muted outline-none transition-colors ' +
          'focus:border-accent-ink ' +
          (error ? 'border-danger ' : 'border-transparent ') +
          className
        }
        aria-invalid={error ? true : undefined}
        {...props}
      />
      {error ? <p className="text-sm text-danger">{error}</p> : null}
    </div>
  )
}
